var e = "1.13.6",
  r = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global || Function("return this")() || {},
  t = Array.prototype,
  o = Object.prototype,
  a = "undefined" != typeof Symbol ? Symbol.prototype : null,
  i = t.push,
  n = t.slice,
  s = o.toString,
  l = o.hasOwnProperty,
  p = "undefined" != typeof ArrayBuffer,
  y = "undefined" != typeof DataView,
  f = Array.isArray,
  u = Object.keys,
  b = Object.create,
  g = p && ArrayBuffer.isView,
  A = isNaN,
  c = isFinite,
  O = !{
    toString: null
  }.propertyIsEnumerable("toString"),
  S = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
  P = 9007199254740991;
export { t as ArrayProto, P as MAX_ARRAY_INDEX, o as ObjProto, a as SymbolProto, e as VERSION, c as _isFinite, A as _isNaN, O as hasEnumBug, l as hasOwnProperty, b as nativeCreate, f as nativeIsArray, g as nativeIsView, u as nativeKeys, S as nonEnumerableProps, i as push, r as root, n as slice, p as supportsArrayBuffer, y as supportsDataView, s as toString };